import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import { Navigation, Scrollbar, A11y, Autoplay } from 'swiper/modules';

// 🔥 영상 2개 import (파일명은 네 프로젝트에 맞게)
import mainVideo1 from '../../assets/image/main_video_sub.mp4';
import mainVideo2 from '../../assets/image/main_video_sub_2.mp4';

const TOTAL_SLIDES = 2;

const MainSwiper = () => {
  const swiperRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(1);
  const [isPlaying, setIsPlaying] = useState(true);

  const handleTogglePlay = () => {
    if (!swiperRef.current) return;
    if (isPlaying) {
      swiperRef.current.autoplay.stop();
      setIsPlaying(false);
    } else {
      swiperRef.current.autoplay.start();
      setIsPlaying(true);
    }
  };

  const renderControls = () => (
    <div className="main-swiper-control">
      {/* 🔹 아주 심플한 카운터만 남김 */}
      <div className="main-swiper-counter">
        <span className="current">{currentIndex.toString().padStart(2, '0')}</span>
        <span className="slash">/</span>
        <span className="total">{TOTAL_SLIDES.toString().padStart(2, '0')}</span>
      </div>

      <div className="main-swiper-buttons">
        <button type="button" className="circle-btn main-swiper-prev" aria-label="이전 배너">
          ‹
        </button>
        <button
          type="button"
          className={`circle-btn main-swiper-play ${isPlaying ? 'is-playing' : ''}`}
          onClick={handleTogglePlay}
          aria-label={isPlaying ? '일시정지' : '자동재생'}
        >
          {isPlaying ? 'Ⅱ' : '▶'}
        </button>
        <button type="button" className="circle-btn main-swiper-next" aria-label="다음 배너">
          ›
        </button>
      </div>
    </div>
  );

  return (
    <div className="main_banner_box">
      <div className="slide_wrap banner">
        <Swiper
          modules={[Navigation, Scrollbar, A11y, Autoplay]}
          slidesPerView={1}
          loop={true}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          onSlideChange={(swiper) => {
            setCurrentIndex(swiper.realIndex + 1);
          }}
          autoplay={isPlaying ? { delay: 4000, disableOnInteraction: false } : false}
          navigation={{
            nextEl: '.main-swiper-next',
            prevEl: '.main-swiper-prev',
          }}
        >
          {/* 1번 슬라이드 */}
          <SwiperSlide className="swiper_slide">
            <div className="slide_image_box">
              <video className="bg_video" src={mainVideo1} autoPlay loop muted playsInline />

              <div className="slide_text_box hero-copy">
                <div className="banner_text">
                  <p className="line1">
                    <span className="accent">서해안 시대</span>, 산업과 교육을 잇는 산학융합의 중심.
                  </p>
                  <p className="line2">
                    <span className="accent">현장형 기술인재</span>를 키우는 기업·대학·연구의 허브,
                  </p>
                  <p className="line3">
                    <span className="brand">충남산학융합원</span>
                  </p>
                </div>

                {/* 텍스트 바로 아래 컨트롤 */}
                {renderControls()}
              </div>
            </div>
          </SwiperSlide>

          {/* 2번 슬라이드 */}
          <SwiperSlide className="swiper_slide">
            <div className="slide_image_box">
              <video className="bg_video" src={mainVideo2} autoPlay loop muted playsInline />

              <div className="slide_text_box hero-copy">
                <div className="banner_text">
                  <p className="line1">
                    <span className="accent">충남 기업 성장</span>을 이끄는 동반자.
                  </p>
                  <p className="line2">
                    산학협력으로 <span className="accent">미래 산업 인재</span>를 키웁니다.
                  </p>
                  <p className="line3">
                    <span className="brand">충남산학융합원</span>
                  </p>
                </div>

                {/* 텍스트 바로 아래 컨트롤 */}
                {renderControls()}
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
};

export default MainSwiper;
